import { getEmailPreviewUrl } from 'EmailData/utils/getEmailPreviewUrl';
import { Link } from 'foundations-components/transitional/components/Link';
import { PROPERTIES, PUBLISH_STATUS } from 'email-management-lib/Shared/constants/frameworkTable';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { jsx as _jsx } from "react/jsx-runtime";
function PreviewLinkCell({
  crmObject
}) {
  const previewKey = getPropertyValue(crmObject, PROPERTIES.PREVIEW_KEY) || '';
  const emailId = getPropertyValue(crmObject, PROPERTIES.MARKETING_EMAIL_ID) || '';
  const fromBuffer = getPropertyValue(crmObject, PROPERTIES.PUBLISH_STATUS) !== PUBLISH_STATUS.PUBLISHED;
  const href = getEmailPreviewUrl(emailId, previewKey, fromBuffer);
  const disabled = !previewKey || !emailId;
  return /*#__PURE__*/_jsx(Link, {
    "data-test-id": "preview-link-cell",
    disabled: disabled,
    external: true,
    href: href,
    children: previewKey
  });
}
export default PreviewLinkCell;